import React from "react";

function AccountSettings() {
  return (
    <div className="page-placeholder" role="presentation">
      <div className="placeholder-card">
        <h2>Profile preferences</h2>
        <p>
          Configure notification rules, manage integrations, and update security
          credentials from this space.
        </p>
        <div className="settings-grid">
          <div>
            <h4>Contact email</h4>
            <p>ops.lead@kropz.com</p>
          </div>
          <div>
            <h4>Multi-factor authentication</h4>
            <p className="status status--success">Enabled</p>
          </div>
          <div>
            <h4>Last password reset</h4>
            <p>14 days ago</p>
          </div>
        </div>
      </div>
      <div className="placeholder-card placeholder-card--outline">
        <h3>Need elevated access?</h3>
        <p>
          Submit a service request so the DigiRock team can onboard your ERP or
          MES data sources.
        </p>
        <button type="button" className="link-button">
          Request support
        </button>
      </div>
    </div>
  );
}

export default AccountSettings;
